(function () {
  function money(cents, currency) {
    var amount = (Number(cents) || 0) / 100;

    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currency || 'GBP',
      }).format(amount);
    } catch (error) {
      return '£' + amount.toFixed(2);
    }
  }

  function parseVariants(root) {
    var script = root.querySelector('[data-artwork-variants]');

    if (!script) return [];

    try {
      return JSON.parse(script.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-artwork-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-artwork-slide]'));
    var previous = root.querySelector('[data-artwork-prev]');
    var next = root.querySelector('[data-artwork-next]');
    var status = root.querySelector('[data-artwork-carousel-status]');
    var initialMediaId = root.dataset.initialMediaId;
    var activeIndex = 0;
    var scrollFrame = null;

    if (initialMediaId) {
      var initialIndex = slides.findIndex(function (slide) {
        return String(slide.dataset.mediaId) === String(initialMediaId);
      });

      if (initialIndex >= 0) {
        activeIndex = initialIndex;
      }
    }

    function clamp(index) {
      return Math.max(0, Math.min(index, slides.length - 1));
    }

    function setIndex(index, shouldScroll) {
      activeIndex = clamp(index);

      if (status) {
        status.textContent = String(activeIndex + 1) + ' / ' + String(Math.max(slides.length, 1));
      }

      if (shouldScroll !== false && slides[activeIndex]) {
        track.scrollTo({
          left: slides[activeIndex].offsetLeft,
          behavior: 'smooth',
        });
      }
    }

    function nearestSlide() {
      if (!slides.length) return 0;

      var left = track.scrollLeft;
      var nearest = 0;
      var nearestDistance = Infinity;

      slides.forEach(function (slide, index) {
        var distance = Math.abs(slide.offsetLeft - left);

        if (distance < nearestDistance) {
          nearest = index;
          nearestDistance = distance;
        }
      });

      return nearest;
    }

    if (previous) {
      previous.addEventListener('click', function () {
        setIndex(activeIndex - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        setIndex(activeIndex + 1);
      });
    }

    track.addEventListener(
      'scroll',
      function () {
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);

        scrollFrame = window.requestAnimationFrame(function () {
          setIndex(nearestSlide(), false);
        });
      },
      { passive: true }
    );

    root.mjArtworkSelectMedia = function (mediaId) {
      if (!mediaId) return;

      var targetIndex = slides.findIndex(function (slide) {
        return String(slide.dataset.mediaId) === String(mediaId);
      });

      if (targetIndex >= 0) {
        setIndex(targetIndex);
      }
    };

    setIndex(activeIndex, false);
  }

  function initOptions(root) {
    var variants = parseVariants(root);
    var variantInput = root.querySelector('[data-artwork-variant-id]');
    var price = root.querySelector('[data-artwork-price]');
    var submit = root.querySelector('[data-artwork-submit]');
    var submitText = root.querySelector('[data-artwork-submit-text]');
    var currency = root.dataset.currency || 'GBP';
    var selectedVariant =
      variants.find(function (variant) {
        return variantInput && String(variant.id) === String(variantInput.value);
      }) || variants[0];
    var selectedOptions = selectedVariant ? selectedVariant.options.slice() : [];

    function updateVariant(variant) {
      if (!variant) return;

      selectedVariant = variant;

      if (variantInput) {
        variantInput.value = variant.id;
      }

      if (price) {
        price.textContent = money(variant.price, currency);
      }

      if (submit) {
        submit.disabled = !variant.available;
      }

      if (submitText) {
        submitText.textContent = variant.available ? 'Add to bag' : 'Sold out';
      }

      if (variant.featured_media && root.mjArtworkSelectMedia) {
        root.mjArtworkSelectMedia(variant.featured_media.id);
      }
    }

    function findVariant(options) {
      var targetOptions = options || selectedOptions;

      if (!variants.length || !selectedOptions.length) return null;

      return variants.find(function (variant) {
        return variant.options.every(function (optionValue, index) {
          return !targetOptions[index] || targetOptions[index] === optionValue;
        });
      });
    }

    function hasAvailableVariantFor(optionPosition, optionValue) {
      if (!variants.length) return true;

      var candidateOptions = selectedOptions.slice();
      candidateOptions[optionPosition] = optionValue;

      return variants.some(function (variant) {
        return (
          variant.available &&
          variant.options.every(function (variantOption, index) {
            return !candidateOptions[index] || candidateOptions[index] === variantOption;
          })
        );
      });
    }

    function updateOptionAvailability() {
      root.querySelectorAll('[data-artwork-option-button]').forEach(function (button) {
        var optionPosition = Number(button.dataset.optionPosition || 0) - 1;
        var optionValue = button.dataset.optionValue || '';
        var isAvailable = hasAvailableVariantFor(optionPosition, optionValue);

        button.disabled = !isAvailable;
        button.classList.toggle('is-unavailable', !isAvailable);
        button.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
      });
    }

    root.querySelectorAll('[data-artwork-option-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;

        var row = button.closest('[data-artwork-option-row]');
        var optionPosition = Number(button.dataset.optionPosition || 0) - 1;

        if (row) {
          row.querySelectorAll('[data-artwork-option-button]').forEach(function (rowButton) {
            rowButton.classList.remove('selected');
            rowButton.setAttribute('aria-pressed', 'false');
          });
        }

        button.classList.add('selected');
        button.setAttribute('aria-pressed', 'true');

        if (optionPosition >= 0) {
          selectedOptions[optionPosition] = button.dataset.optionValue || '';
          updateVariant(findVariant());
        }

        updateOptionAvailability();
      });
    });

    updateOptionAvailability();
  }

  function init(root) {
    if (!root || root.dataset.artworkReady === 'true') return;

    root.dataset.artworkReady = 'true';
    initCarousel(root);
    initOptions(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mj-artwork-product]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
